export default __webpack_public_path__ + "static/media/loader.936f9f69.gif";